<template>
    <div id="content">
        <b-navbar type="dark" variant="dark" fixed="top" toggleable="sm">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand to="/home" active> 🏢 </b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                <b-nav-item @click="$router.push('/maps')"><b-icon-map></b-icon-map> Map </b-nav-item>
                <!-- <b-nav-item @click="$router.push('/building')"><b-icon-building></b-icon-building> Building </b-nav-item> -->
                <b-nav-item @click="$router.push('/data-warehouse')"><b-icon-file-earmark></b-icon-file-earmark> Data Warehouse </b-nav-item>
                <b-nav-item active><b-icon-newspaper></b-icon-newspaper> Reports </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                <b-nav-item @click="logout()">
                    <b-icon-box-arrow-left></b-icon-box-arrow-left>
                    Logout {{username}}
                    <b-avatar class="mr-3" size="1.3em">
                    <v-gravatar :size="100" default-img="retro" :email="username" />
                    </b-avatar>
                </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <main role="main" class="mx-auto" style="width: 700px">
            <br>
            <h6> Select a Report Type: </h6>
            <b-form-select v-model="selected_report_style" :options="report_style_options"> </b-form-select>

            <div v-if="selected_report_style == 'Threshold Test'">
                <br> 
                <p> The Threshold test lists all APs greater than an input threshold in a selected campus in order of highest to lowest density counts for a selected time period. </p>
                <br>
                <b-container>
                    <b-row>
                        <b-col cols="5">
                            <h6> Campus Select: </h6>
                            <b-form-group>
                                <b-form-radio-group v-model = "threshold_test_campus_select">
                                    <b-form-radio value="UPC"> UPC </b-form-radio>
                                    <b-form-radio value="HSC"> HSC </b-form-radio>
                                    <b-form-radio value="NUP"> NUP </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="7">
                            <h6> Time Period: </h6>
                            <b-form-group>
                                <b-form-radio-group v-model = "threshold_test_time_period">
                                    <b-form-radio value="daily"> Daily </b-form-radio>
                                    <b-form-radio value="weekly"> Weekly </b-form-radio>
                                    <b-form-radio value="monthly"> Monthly </b-form-radio>
                                    <b-form-radio value="custom"> Custom </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-container>
                <br>

                <div v-if="threshold_test_time_period == 'daily'">
                    <h6> Date Select </h6>
                    <b-form-datepicker v-model="threshold_test_date" class="mb-2"></b-form-datepicker>
                    <br>
                </div>

                <div v-if="threshold_test_time_period == 'custom'">
                    <b-container>
                        <b-row>
                        <b-col cols="6">
                            <h6> Start Date Select: </h6>
                            <b-form-datepicker v-model="threshold_test_start_date" class="mb-2"></b-form-datepicker>
                        </b-col>
                        <b-col cols="6">
                            <h6> End Date Select: </h6>
                            <b-form-datepicker v-model="threshold_test_end_date" class="mb-2"></b-form-datepicker>
                        </b-col>
                    </b-row>
                    </b-container>
                </div>

                <br>
                <h6> Threshold: </h6>
                <b-form-input v-model="threshold_test_value" type="number" placeholder="Enter value here"></b-form-input>
                <br>

                <div v-if="threshold_test_campus_select != null && threshold_test_time_period != null">
                    <b-button @click="report('threshold_test')" v-b-modal.report variant="outline-primary"> Generate Report </b-button>

                    <div v-if="threshold_report_success">
                        <br>
                        <b-container fluid> <!-- made this fluid for new table -->
                            <b-row>
                                <b-col cols = "10"> Report: {{ threshold_report_metadata }} </b-col>
                                <b-col cols = "1"> <b-button @click="downloadCSV('one', 'threshold')" size ="sm" variant="success"> CSV </b-button> </b-col>
                                <b-col cols = "1"> <b-button @click="downloadPDF('one', 'threshold')" size ="sm" variant="primary"> PDF </b-button> </b-col>
                            </b-row>
                            <br>
                            <!-- new table style -->
                            <b-row>
                                <!-- sort controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Sort"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="sortBySelect"
                                    >
                                    <b-input-group size = "sm">
                                        <b-form-select v-model="sortStyle" id="sortBySelect" :options="sortStyleOneFields">
                                            <template #first>
                                                <option value=""> -- none -- </option>
                                            </template>
                                        </b-form-select>
                                        <b-form-select v-model="sortDesc" size="sm" :disabled="!sortStyle">
                                            <option :value="false"> Asc </option>
                                            <option :value="true"> Desc </option>
                                        </b-form-select>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end sort controller -->

                                <!-- filter controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Filter"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="filterInput"
                                    >
                                    <b-input-group size="sm">
                                        <b-form-input
                                            v-model="filterBy"
                                            type="search"
                                            id="filterInput"
                                            placeholder="Type to Search"
                                        > </b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filterBy" @click="filter = ''"> Clear </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end filter controller -->

                                <!-- pagination controller -->
                                <b-col sm="5" md="6">
                                    <b-form-group
                                        label="Per page"
                                        label-cols-sm="6"
                                        label-cols-md="4"
                                        label-cols-lg="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="perPageSelect"
                                    >
                                    <b-form-select
                                        v-model="resultsPerPage"
                                        id="perPageSelect"
                                        size="sm"
                                        :options="resultsPerPageOptions"
                                    > </b-form-select>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="7" md="6">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="resultsPerPage"
                                        align="fill"
                                        size="sm"
                                    > </b-pagination>
                                </b-col>
                                <!-- end pagination controller -->
                            </b-row>

                            <!-- table data -->
                            <b-table
                                show-empty
                                small
                                stacked="md"
                                :items="threshold_test_results"
                                :fields="report_style_one_fields"
                                :current-page="currentPage"
                                :per-page="resultsPerPage"
                                :filter="filterBy"
                                :filter-included-fields="filterOn"
                                :sort-by.sync="sortStyle"
                                :sort-desc.sync="sortDesc"
                                :sort-direction="sortDirection"
                                @filtered="onFiltered"
                            >

                            </b-table>
                            <!-- end table data -->

                            <!-- end new table style --> 

                            <!-- old table style -->
                            <!-- <b-row>
                                <b-col>
                                    <b-table striped hover :items="threshold_test_results" :fields="report_style_one_fields"> </b-table>
                                </b-col>
                            </b-row> -->
                            <!-- end old table style --> 
                        </b-container>
                    </div>

                    <div v-if="!threshold_report_success && threshold_report_success != null">
                        <br> Sorry! Looks like we don't have the requested data. :(
                    </div>
                </div>
            </div>

            <div v-if="selected_report_style == 'Compliance Report'">
                <br>
                <p> The Compliance Report allows you to set custom thresholds per floor of specific building(s) in a given campus and view any APs in excess of the threholds. </p>
                <br>
                <b-container>
                    <b-row>
                        <b-col cols="6">
                            <h6> Campus Select: </h6>
                            <b-form-group>
                                <b-form-radio-group v-model = "compliance_report_campus_select">
                                    <b-form-radio value="UPC" @change="getBuildingList('UPC', 'compliance query')"> UPC </b-form-radio>
                                    <b-form-radio value="HSC" @change="getBuildingList('HSC', 'compliance query')"> HSC </b-form-radio>
                                    <b-form-radio value="NUP" @change="getBuildingList('NUP', 'compliance query')"> NUP </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <h6> Date Select: </h6> 
                            <b-form-datepicker v-model="compliance_report_date" class="mb-2"></b-form-datepicker>
                            <br>
                        </b-col>
                    </b-row>
                </b-container>

                <div v-if="compliance_report_campus_select != null">
                    <h6> Select a building from the list: </h6>
                    <b-form-select :select-size="10" v-model="compliance_report_selected_building" @change="getFloors(compliance_report_campus_select, compliance_report_selected_building, 'compliance query')">
                        <option v-for="building in compliance_report_building_list" v-bind:key="building"> {{ building }} </option>
                    </b-form-select>
                    
                    <div v-if="compliance_report_selected_building != null">
                        <br> Enter thresholds to set for each building's floors: <br> <br>
                        <div v-for="floor in compliance_report_floor_list" v-bind:key="floor">
                            {{ floor }} : <input> 
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="selected_report_style == 'Building Watcher'">
                <br>
                <p> The Building Watcher allows you to select a specific building and view its stats over the past week or month.
                <br> <br>
                <b-container>
                    <b-row>
                        <b-col cols="6">
                            <h6> Campus Select: </h6>
                            <b-form-group>
                                <b-form-radio-group v-model = "building_watcher_campus_select">
                                    <b-form-radio value="UPC" @change="getBuildingList('UPC', 'building watcher')"> UPC </b-form-radio>
                                    <b-form-radio value="HSC" @change="getBuildingList('HSC', 'building watcher')"> HSC </b-form-radio>
                                    <b-form-radio value="NUP" @change="getBuildingList('NUP', 'building watcher')"> NUP </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <h6> Time Period Select: </h6> 
                            <b-form-group>
                                <b-form-radio-group v-model = "building_watcher_time_frame">
                                    <b-form-radio value="past_week"> Past Week </b-form-radio>
                                    <b-form-radio value="past_month"> Past Month </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                            <br>
                        </b-col>
                    </b-row>
                </b-container>

                <div v-if="building_watcher_campus_select != null">
                    <h6> Select a building to monitor: </h6>
                    <b-form-select :select-size="10" v-model="building_watcher_selected_building">
                        <option v-for="building in building_watcher_report_building_list" v-bind:key="building"> {{ building }} </option>
                    </b-form-select>
                </div>
                <br>
                <div v-if="(building_watcher_selected_building != null && building_watcher_time_frame != null) || first_building_watcher_made">
                    <b-button @click="report('building watcher')" v-b-modal.report variant="outline-primary"> Generate Report </b-button>

                    <div v-if="building_watcher_success">
                        <br>
                        <b-container>
                            <b-row>
                                <b-col cols = "10"> Report: {{ building_watcher_metadata }}  </b-col>
                                <b-col cols = "1"> <b-button @click="downloadCSV('one', 'building watcher')" size ="sm" variant="success"> CSV </b-button> </b-col>
                                <b-col cols = "1"> <b-button @click="downloadPDF('one', 'building watcher')" size ="sm" variant="primary"> PDF </b-button> </b-col>
                            </b-row>
                            <br>
                            <!-- new table style -->
                            <b-row>
                                <!-- sort controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Sort"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="sortBySelect"
                                    >
                                    <b-input-group size = "sm">
                                        <b-form-select v-model="sortStyle" id="sortBySelect" :options="sortStyleOneFields">
                                            <template #first>
                                                <option value=""> -- none -- </option>
                                            </template>
                                        </b-form-select>
                                        <b-form-select v-model="sortDesc" size="sm" :disabled="!sortStyle">
                                            <option :value="false"> Asc </option>
                                            <option :value="true"> Desc </option>
                                        </b-form-select>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end sort controller -->

                                <!-- filter controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Filter"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="filterInput"
                                    >
                                    <b-input-group size="sm">
                                        <b-form-input
                                            v-model="filterBy"
                                            type="search"
                                            id="filterInput"
                                            placeholder="Type to Search"
                                        > </b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filterBy" @click="filter = ''"> Clear </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end filter controller -->

                                <!-- pagination controller -->
                                <b-col sm="5" md="6">
                                    <b-form-group
                                        label="Per page"
                                        label-cols-sm="6"
                                        label-cols-md="4"
                                        label-cols-lg="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="perPageSelect"
                                    >
                                    <b-form-select
                                        v-model="resultsPerPage"
                                        id="perPageSelect"
                                        size="sm"
                                        :options="resultsPerPageOptions"
                                    > </b-form-select>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="7" md="6">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="resultsPerPage"
                                        align="fill"
                                        size="sm"
                                    > </b-pagination>
                                </b-col>
                                <!-- end pagination controller -->
                            </b-row>

                            <!-- table data -->
                            <b-table
                                show-empty
                                small
                                stacked="md"
                                :items="building_watcher_results"
                                :fields="report_style_one_fields"
                                :current-page="currentPage"
                                :per-page="resultsPerPage"
                                :filter="filterBy"
                                :filter-included-fields="filterOn"
                                :sort-by.sync="sortStyle"
                                :sort-desc.sync="sortDesc"
                                :sort-direction="sortDirection"
                                @filtered="onFiltered"
                            >

                            </b-table>
                            <!-- <b-row>
                                <b-col>
                                    <b-table striped hover :items="building_watcher_results" :fields="report_style_one_fields"> </b-table>
                                </b-col>
                            </b-row> -->
                        </b-container>
                    </div>

                    <div v-if="!building_watcher_success && building_watcher_success != null">
                        <br> Sorry! Looks like we don't have the requested data. :(
                    </div>
                </div>

            </div>

            <div v-if="selected_report_style == 'Top 10 Report'">
                <br>
                <p> The top 10 report shows the top 10 Buildings in a given campus over the past week or month. </p>
                <br>
                <b-container>
                    <b-row>
                        <b-col cols="6">
                            <h6> Campus Select: </h6>
                            <b-form-group>
                                <b-form-radio-group v-model = "top_ten_campus_select">
                                    <b-form-radio value="UPC"> UPC </b-form-radio>
                                    <b-form-radio value="HSC"> HSC </b-form-radio>
                                    <b-form-radio value="NUP"> NUP </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <h6> Time Period Select: </h6> 
                            <b-form-group>
                                <b-form-radio-group v-model = "top_ten_time_frame">
                                    <b-form-radio value="past_week"> Past Week </b-form-radio>
                                    <b-form-radio value="past_month"> Past Month </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                            <br>
                        </b-col>
                    </b-row>
                </b-container>

                <div v-if="(top_ten_campus_select != null && top_ten_time_frame != null) || first_top_ten_made">
                    <b-button @click="report('top ten')" v-b-modal.report variant="outline-primary"> Generate Report </b-button>

                    <div v-if="top_ten_success">
                        <br>
                        <b-container>
                            <b-row>
                                <b-col cols = "10"> Report: {{ top_ten_metadata }}  </b-col>
                                <b-col cols = "1"> <b-button @click="downloadCSV('two', 'top ten')" size ="sm" variant="success"> CSV </b-button> </b-col>
                                <b-col cols = "1"> <b-button @click="downloadPDF('two', 'top ten')" size ="sm" variant="primary"> PDF </b-button> </b-col>
                            </b-row>
                            <!-- new table style -->
                            <br>
                            <b-row>
                                <!-- sort controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Sort"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="sortBySelect"
                                    >
                                    <b-input-group size = "sm">
                                        <b-form-select v-model="sortStyle" id="sortBySelect" :options="sortStyleTwoFields">
                                            <template #first>
                                                <option value=""> -- none -- </option>
                                            </template>
                                        </b-form-select>
                                        <b-form-select v-model="sortDesc" size="sm" :disabled="!sortStyle">
                                            <option :value="false"> Asc </option>
                                            <option :value="true"> Desc </option>
                                        </b-form-select>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end sort controller -->

                                <!-- filter controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Filter"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="filterInput"
                                    >
                                    <b-input-group size="sm">
                                        <b-form-input
                                            v-model="filterBy"
                                            type="search"
                                            id="filterInput"
                                            placeholder="Type to Search"
                                        > </b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filterBy" @click="filter = ''"> Clear </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end filter controller -->

                                <!-- pagination controller -->
                                <b-col sm="5" md="6">
                                    <b-form-group
                                        label="Per page"
                                        label-cols-sm="6"
                                        label-cols-md="4"
                                        label-cols-lg="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="perPageSelect"
                                    >
                                    <b-form-select
                                        v-model="resultsPerPage"
                                        id="perPageSelect"
                                        size="sm"
                                        :options="resultsPerPageOptions"
                                    > </b-form-select>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="7" md="6">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="resultsPerPage"
                                        align="fill"
                                        size="sm"
                                    > </b-pagination>
                                </b-col>
                                <!-- end pagination controller -->
                            </b-row>

                            <!-- table data -->
                            <b-table
                                show-empty
                                small
                                stacked="md"
                                :items="top_ten_results"
                                :fields="report_style_two_fields"
                                :current-page="currentPage"
                                :per-page="resultsPerPage"
                                :filter="filterBy"
                                :filter-included-fields="filterOn"
                                :sort-by.sync="sortStyle"
                                :sort-desc.sync="sortDesc"
                                :sort-direction="sortDirection"
                                @filtered="onFiltered"
                            >

                            </b-table>

                            <!-- <br>
                            <b-row>
                                <b-col>
                                    <b-table striped hover :items="top_ten_results" :fields="report_style_two_fields"> </b-table>
                                </b-col>
                            </b-row> -->
                        </b-container>
                    </div>

                    <div v-if="!top_ten_success && top_ten_success != null">
                        <br> Sorry! Looks like we don't have the requested data. :(
                    </div>
                </div>
            </div>

            <div v-if="selected_report_style == 'Floor Manager'">
                <br>
                <p> The Floor Manager report shows the stats of a specified floor within a building over the past week </p>
                <br>
                <h6> Campus Select: </h6>
                <b-form-group>
                    <b-form-radio-group v-model = "floor_manager_campus_select">
                        <b-form-radio value="UPC" @change="getBuildingList('UPC', 'floor manager')"> UPC </b-form-radio>
                        <b-form-radio value="HSC" @change="getBuildingList('HSC', 'floor manager')"> HSC </b-form-radio>
                        <b-form-radio value="NUP" @change="getBuildingList('NUP', 'floor manager')"> NUP </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
                <br>
                <b-container>
                    <b-row>
                        <b-col cols="6">
                            <div v-if="floor_manager_campus_select != null">
                                <h6> Select a building to monitor: </h6>
                                <b-form-select :select-size="10" v-model="floor_manager_building_select" @change="getFloors(floor_manager_campus_select, floor_manager_building_select, 'floor manager')">
                                    <option v-for="building in floor_manager_building_list" v-bind:key="building"> {{ building }} </option>
                                </b-form-select>
                            </div>
                        </b-col>
                        <b-col cols="6">
                            <div v-if="floor_manager_building_select != null">
                                <h6> Select a floor to monitor: </h6>
                                <b-form-select :select-size="10" v-model="floor_manager_floor_select">
                                    <option v-for="floor in floor_manager_floor_list" v-bind:key="floor"> {{ floor }} </option>
                                </b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
                <br>
                <div v-if="floor_manager_floor_select || first_floor_manager_made">
                    <b-button @click="report('floor manager')" v-b-modal.report variant="outline-primary"> Generate Report </b-button>

                    <div v-if="floor_manager_success">
                        <br>
                        <b-container>
                            <b-row>
                                <b-col cols = "10"> Report: {{ floor_manager_metadata }}  </b-col>
                                <b-col cols = "1"> <b-button @click="downloadCSV('one', 'floor manager')" size ="sm" variant="success"> CSV </b-button> </b-col>
                                <b-col cols = "1"> <b-button @click="downloadPDF('one', 'floor manager')" size ="sm" variant="primary"> PDF </b-button> </b-col>
                            </b-row>
                            <!-- new table style -->
                            <br>
                            <b-row>
                                <!-- sort controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Sort"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="sortBySelect"
                                    >
                                    <b-input-group size = "sm">
                                        <b-form-select v-model="sortStyle" id="sortBySelect" :options="sortStyleOneFields">
                                            <template #first>
                                                <option value=""> -- none -- </option>
                                            </template>
                                        </b-form-select>
                                        <b-form-select v-model="sortDesc" size="sm" :disabled="!sortStyle">
                                            <option :value="false"> Asc </option>
                                            <option :value="true"> Desc </option>
                                        </b-form-select>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end sort controller -->

                                <!-- filter controller -->
                                <b-col lg="6">
                                    <b-form-group
                                        label="Filter"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="filterInput"
                                    >
                                    <b-input-group size="sm">
                                        <b-form-input
                                            v-model="filterBy"
                                            type="search"
                                            id="filterInput"
                                            placeholder="Type to Search"
                                        > </b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filterBy" @click="filter = ''"> Clear </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <!-- end filter controller -->

                                <!-- pagination controller -->
                                <b-col sm="5" md="6">
                                    <b-form-group
                                        label="Per page"
                                        label-cols-sm="6"
                                        label-cols-md="4"
                                        label-cols-lg="3"
                                        label-align-sm="right"
                                        label-size="sm"
                                        label-for="perPageSelect"
                                    >
                                    <b-form-select
                                        v-model="resultsPerPage"
                                        id="perPageSelect"
                                        size="sm"
                                        :options="resultsPerPageOptions"
                                    > </b-form-select>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="7" md="6">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="resultsPerPage"
                                        align="fill"
                                        size="sm"
                                    > </b-pagination>
                                </b-col>
                                <!-- end pagination controller -->
                            </b-row>

                            <!-- table data -->
                            <b-table
                                show-empty
                                small
                                stacked="md"
                                :items="floor_manager_results"
                                :fields="report_style_one_fields"
                                :current-page="currentPage"
                                :per-page="resultsPerPage"
                                :filter="filterBy"
                                :filter-included-fields="filterOn"
                                :sort-by.sync="sortStyle"
                                :sort-desc.sync="sortDesc"
                                :sort-direction="sortDirection"
                                @filtered="onFiltered"
                            >

                            </b-table>
                            <!-- <br> 
                            <b-row>
                                <b-col>
                                    <b-table striped hover :items="floor_manager_results" :fields="report_style_one_fields"> </b-table>
                                </b-col>
                            </b-row> -->
                        </b-container>
                    </div>

                    <div v-if="!floor_manager_success && floor_manager_success != null">
                        <br> Sorry! Looks like we don't have the requested data. :(
                    </div>
                </div>

            </div>

            <div v-if="selected_report_style == 'Busiest Days'">
                <br>
                <p> The Busiest Days report shows which days a given building was busiest in the past week </p>
                <br>
                <h6> Campus Select: </h6>
                <b-form-group>
                    <b-form-radio-group v-model = "busiest_time_campus_select">
                        <b-form-radio value="UPC" @change="getBuildingList('UPC', 'busiest time')"> UPC </b-form-radio>
                        <b-form-radio value="HSC" @change="getBuildingList('HSC', 'busiest time')"> HSC </b-form-radio>
                        <b-form-radio value="NUP" @change="getBuildingList('NUP', 'busiest time')"> NUP </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
                <br>
                <div v-if="busiest_time_campus_select != null">
                    <h6> Select a building to monitor: </h6>
                    <b-form-select :select-size="10" v-model="busiest_time_selected_building">
                        <option v-for="building in busiest_time_report_building_list" v-bind:key="building"> {{ building }} </option>
                    </b-form-select>
                </div>
                <br>
                <div v-if="busiest_time_selected_building != null || first_busiest_time_made">
                    <b-button @click="report('busiest time')" v-b-modal.report variant="outline-primary" id="busiest_times_button"> Generate Report </b-button>
                    
                    <div v-show="busiest_time_success">
                        <br>
                        <b-container>
                            <b-row>
                                <b-col cols = "10"> Report: {{ busiest_time_metadata }}  </b-col>
                                <b-col cols = "1"> <b-button @click="downloadCSV('three', 'busiest times')" size ="sm" variant="success"> CSV </b-button> </b-col>
                                <b-col cols = "1"> <b-button @click="downloadPDF('three', 'busiest times')" size ="sm" variant="primary"> PDF </b-button> </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <canvas id='busiest_times_chart'></canvas>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>

                    <div v-if="!busiest_time_success && busiest_time_success != null">
                        <br> Sorry! Looks like we don't have the requested data. :(
                    </div>

                </div>
            </div>

        </main>
    </div>
</template>

<script>
import axios from "axios";
import html2pdf from 'html2pdf.js';
import Chart from 'chart.js';
export default {
    data: function() {
        return {
            selected_report_style: null,
            report_style_options: [
                'Building Watcher', 'Busiest Days', 'Compliance Report',
                'Floor Manager', 'Threshold Test', 'Top 10 Report'
            ],
            compliance_report_campus_select: 'UPC',
            compliance_report_date: new Date(),
            compliance_report_building_list: this.getBuildingList('UPC', 'compliance query'),
            compliance_report_selected_building: null,
            compliance_report_floor_list: [],
            building_watcher_campus_select: 'UPC',
            building_watcher_time_frame: 'past_week',
            building_watcher_report_building_list: this.getBuildingList('UPC', 'building watcher'),
            building_watcher_selected_building: null,
            first_building_watcher_made: false,
            building_watcher_success: null,
            building_watcher_metadata: null,
            building_watcher_results: [],
            top_ten_campus_select: 'UPC',
            top_ten_time_frame: 'past_week',
            first_top_ten_made: null,
            top_ten_success: null,
            top_ten_metadata: null,
            top_ten_results: [],
            busiest_time_campus_select: 'UPC',
            busiest_time_report_building_list: this.getBuildingList('UPC', 'busiest time'),
            busiest_time_selected_building: null,
            first_busiest_time_made: false,
            busiest_time_success: null,
            busiest_time_metadata: null,
            busiest_time_results: [],
            busiest_time_days: [],
            floor_manager_campus_select: 'UPC',
            floor_manager_building_list: this.getBuildingList('UPC', 'floor manager'),
            floor_manager_building_select: 'ACB',
            floor_manager_floor_list: this.getFloors('UPC', 'ACC', 'floor manager'),
            floor_manager_floor_select: 'Basement',
            first_floor_manager_made: false,
            floor_manager_success: null,
            floor_manager_metadata: null,
            floor_manager_results: null,
            threshold_test_campus_select: 'UPC',
            threshold_test_time_period: 'daily',
            threshold_test_date: new Date(),
            threshold_test_start_date: null,
            threshold_test_end_date: null,
            threshold_test_value: 0,
            threshold_report_success: null,
            threshold_report_metadata: null,
            threshold_test_results: [], 
            //table variables 
            sortStyle: '',
            sortDesc: false, //default is sort asc so this is false,
            sortDirection: 'asc', //default sorting direction
            filterBy: null,
            filterOn: [], 
            resultsPerPage: 5, // default value
            resultsPerPageOptions: [5, 10, 15, 20], //range of values
            currentPage: 1, //default - start on first page
            totalRows: 1, 
            report_style_one_fields: [ 
                { key: 'Building', label: 'Building Code', sortable: true },
                { key: 'Floor', label: 'Floor', sortable: true },
                { key: 'AP', label: 'Access Point', sortable: true},
                { key: 'Count', label: 'Count', sortable: true }
            ],
            report_style_two_fields: [
                { key: 'Building', label: 'Building Code', sortable: true },
                { key: 'Count', label: 'Count', sortable: true }
            ],
        }
    },
    computed: {
        sortStyleOneFields() { // this is what populates your options field for sorting
            return this.report_style_one_fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                });
        },
        sortStyleTwoFields() {
            return this.report_style_two_fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                });
        },
        username() {
        return this.$store.state.user.username;
        },
    },
    methods: {
        logout() {
            this.$router.push(
                '/users/logout'
            );
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        report(type) {
            if (type === 'threshold_test') {
                axios.get(
                    process.env.VUE_APP_API_URL + '/reports/threshold?time_period=' + this.threshold_test_time_period + '&date=' + this.threshold_test_date + '&start_date=' + this.threshold_test_start_date + '&end_date=' + this.threshold_test_end_date + '&campus=' + this.threshold_test_campus_select + '&threshold=' + this.threshold_test_value,
                    { headers: { authorization: localStorage.getItem('density.token') }}
                ).then((response) => {
                    if (response.data === "") {
                        this.threshold_report_success = false;
                    } else {
                        this.threshold_test_results = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.threshold_test_results.push(response.data[i]);
                        }
                        this.totalRows = this.threshold_test_results.length;
                        this.threshold_report_success = true;
                        this.threshold_report_metadata = this.threshold_test_time_period + ' on ' + this.threshold_test_campus_select + ' with threshold ' + this.threshold_test_value;
                    }
                });
            } else if (type === 'compliance') {
                //pause: refactor this report
                return;
            } else if (type === 'building watcher') {
                axios.get(
                    process.env.VUE_APP_API_URL + '/reports/buildingWatcher?campus=' + this.building_watcher_campus_select + '&building=' + this.building_watcher_selected_building + '&time_period=' + this.building_watcher_time_frame,
                    { headers: { authorization: localStorage.getItem('density.token') }}
                ).then((response) => {
                    if (response.data === "") {
                        this.building_watcher_success = false;
                    } else {
                        this.building_watcher_results = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.building_watcher_results.push(response.data[i]);
                        }
                        this.totalRows = this.building_watcher_results.length;
                        this.building_watcher_success = true;
                        if (this.building_watcher_time_frame === 'past_week') {
                            this.building_watcher_metadata = this.building_watcher_selected_building + ' in ' + this.building_watcher_campus_select + ' over the past week';
                        } else {
                            this.building_watcher_metadata = this.building_watcher_selected_building + ' in ' + this.building_watcher_campus_select + ' over the past month';
                        }
                    }
                });
                this.first_building_watcher_made = true;
            } else if (type === 'top ten') {
                axios.get(
                    process.env.VUE_APP_API_URL + '/reports/topTen?campus=' + this.top_ten_campus_select + '&time_period=' + this.top_ten_time_frame,
                    { headers: { authorization: localStorage.getItem('density.token') }}
                ).then((response) => {
                    if (response.data === "") {
                        this.top_ten_success = false;
                    } else {
                        this.top_ten_results = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.top_ten_results.push(response.data[i]);
                        }
                        this.totalRows = this.top_ten_results.length;
                        this.top_ten_success = true;
                        if (this.top_ten_time_frame === 'past_week') {
                            this.top_ten_metadata = 'Top Ten in ' + this.top_ten_campus_select + ' over the past week';
                        } else {
                            this.top_ten_metadata = 'Top Ten in ' + this.top_ten_campus_select + ' over the past month';
                        }
                    }
                });
                this.first_top_ten_made = true;
            } else if (type === 'floor manager') {
                axios.get(
                    process.env.VUE_APP_API_URL + '/reports/floorManager?campus=' + this.floor_manager_campus_select + '&building=' + this.floor_manager_building_select + '&floor=' + this.floor_manager_floor_select,
                    { headers: { authorization: localStorage.getItem('density.token') }}
                ).then((response) => {
                    if (response.data === "") {
                        this.floor_manager_success = false;
                    } else {
                        this.floor_manager_results = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.floor_manager_results.push(response.data[i]);
                        }
                        this.totalRows = this.floor_manager_results.length;
                        this.floor_manager_success = true;
                        this.floor_manager_metadata = this.floor_manager_floor_select + ' in ' + this.floor_manager_building_select + ' over the past week';
                    }
                });
                this.first_floor_manager_made = true;
            } else if (type === 'busiest time') {
                axios.get(
                    process.env.VUE_APP_API_URL + '/reports/busiestDays?campus=' + this.busiest_time_campus_select + '&building=' + this.busiest_time_selected_building,
                    { headers: { authorization: localStorage.getItem('density.token') }}
                ).then((response) => {
                    if (response.data === "") {
                        this.busiest_time_success = false;
                    } else {
                        this.busiest_time_success = true;
                        this.busiest_time_days = response.data.labels;
                        this.busiest_time_results = [];
                        for (let i = 0; i < response.data.values.length; i++) {
                            this.busiest_time_results.push(response.data.values[i]);
                        }
                        this.busiest_time_metadata = 'busiest days on ' + this.busiest_time_selected_building + ' in ' + this.busiest_time_campus_select;
                        var ctx = document.getElementById('busiest_times_chart').getContext('2d');
                        new Chart(ctx, {
                            type: 'line',
                            data: {
                                labels: this.busiest_time_days,
                                datasets: [{
                                    label: 'Number of Connections',
                                    backgroundColor: 'rgb(187, 194, 226)',
                                    borderColor: 'rgb(207, 204, 214)',
                                    data: this.busiest_time_results
                                }]
                            },
                            options: {}
                        });
                    }
                });
                this.first_busiest_time_made = true;
            }
        },
        getBuildingList(campus, queryType) {
            axios.get(
                    process.env.VUE_APP_API_URL + '/reports/buildingNames?campus=' + campus,
                    { headers: { authorization: localStorage.getItem('density.token') }}
                ).then((response) => {
                    if (queryType === 'compliance query') {
                        this.compliance_report_building_list = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.compliance_report_building_list.push(response.data[i]);
                        }
                    } else if (queryType === 'building watcher') {
                        this.building_watcher_report_building_list = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.building_watcher_report_building_list.push(response.data[i]);
                        }
                    } else if (queryType === 'busiest time') {
                        this.busiest_time_report_building_list = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.busiest_time_report_building_list.push(response.data[i]);
                        }
                    } else if (queryType === 'floor manager') {
                        this.floor_manager_building_list = [];
                        for (let i = 0; i < response.data.length; i++) {
                            this.floor_manager_building_list.push(response.data[i]);
                        }
                    } 
                });
        },
        getFloors(campus, building, queryType) {
            let floors = [];
            axios.get(
                process.env.VUE_APP_API_URL + '/reports/floorList?campus=' + campus + '&building=' + building,
                { headers: { authorization: localStorage.getItem('density.token') }}
            ).then((response) => {
                console.log("floorlist:", response);
                for (let i = 0; i < response.data.length; i++) {
                    floors.push(response.data[i]);
                }

                if (queryType === 'compliance query') {
                    this.compliance_report_floor_list = floors;
                } else if (queryType === 'floor manager') {
                    this.floor_manager_floor_list = floors;
                }

            }); 
        },
        downloadCSV(style, type) {
            if (style === 'one') {
                let csv = 'AP,Building,Floor,Count\n';
                const anchor = document.createElement('a');
                if (type === 'threshold') {
                    this.threshold_test_results.forEach((row) => {
                        csv += row.AP + ',' + row.Building + ',' + row.Floor + ',' + row.Count;
                        csv += "\n";
                    });
                    anchor.download = 'threshold_report_' + this.threshold_test_date + '_' + this.threshold_test_campus_select + '.csv';
                } else if (type === 'building watcher') {
                    this.building_watcher_results.forEach((row) => {
                        csv += row.AP + ',' + row.Building + ',' + row.Floor + ',' + row.Count;
                        csv += "\n";
                    });
                    anchor.download = 'building_watcher_' + this.building_watcher_time_frame + '_' + this.building_watcher_campus_select + '.csv';
                } else if (type === 'floor manager') {
                    this.floor_manager_results.forEach((row) => {
                        csv += row.AP + ',' + row.Building + ',' + row.Floor + ',' + row.Count;
                        csv += '\n';
                    });
                    anchor.download = 'floor_manager_past_week_' + this.floor_manager_campus_select + '.csv'
                }
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.click();
            } else if (style === 'two') {
                let csv = 'Building, Count\n';
                const anchor = document.createElement('a');
                if (type === 'top ten') {
                    this.top_ten_results.forEach((row) => {
                        csv += row.Building + ',' + row.Count;
                        csv += '\n';
                    });
                    anchor.download = 'top_ten_' + this.top_ten_time_frame + '_' + this.top_ten_campus_select + '.csv';
                }
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.click();
            } else if (style === 'three') {
                let csv = 'Day, Count\n';
                const anchor = document.createElement('a');
                if (type === 'busiest times') {
                    for (let i = 0; i < 7; i++) {
                        csv += this.busiest_time_days[i] + ',' + this.busiest_time_results[i];
                        csv += '\n';
                    }
                    anchor.download = 'busiest_days_past_week' + '_' + this.busiest_time_campus_select + '_' + this.busiest_time_selected_building + '.csv';
                }
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.click();
            }
        },
        downloadPDF(style, type) {
            if (style === 'one') {
                let report_area = document.createElement('div');
                let table = document.createElement('table');
                let head1 = document.createElement('th');
                let head2 = document.createElement('th');
                let head3 = document.createElement('th');
                let head4 = document.createElement('th');
                let heading_row = document.createElement('tr');
                head1.innerHTML = 'Building Code'; 
                head2.innerHTML = 'Floor';
                head3.innerHTML = 'Access Point';
                head4.innerHTML = 'Count';
                heading_row.appendChild(head1);
                heading_row.appendChild(head2);
                heading_row.appendChild(head3);
                heading_row.appendChild(head4);
                table.appendChild(heading_row);
                let header = document.createElement('h3');
                let table_inputs = [];
                let options = {};
                
                if (type === 'threshold') {
                    table_inputs = this.threshold_test_results;

                    options = {
                        filename: 'threshold_report_' + this.threshold_test_campus_select + '_' + this.threshold_test_date + '.pdf',
                        margin: 2,
                        html2canvas: { scale: 3, y: 0,  scrollY: 0},
                        pagebreak: { mode: 'css' }
                    };

                    header.innerHTML = this.threshold_report_metadata;
                } else if (type === 'building watcher') {
                    table_inputs = this.building_watcher_results;

                    options = {
                        filename: 'building_watcher_' + this.building_watcher_campus_select + '_' + this.building_watcher_time_frame + '.pdf',
                        margin: 2,
                        html2canvas: { scale: 3, y: 0,  scrollY: 0},
                        pagebreak: { mode: 'css' }
                    }

                    header.innerHTML = this.building_watcher_metadata;
                } else if (type === 'floor manager') {
                    table_inputs = this.floor_manager_results;

                    options = {
                        filename: 'floor_manager_' + this.floor_manager_campus_select + '_past_week.pdf',
                        margin: 2,
                        html2canvas: { scale: 3, y: 0,  scrollY: 0},
                        pagebreak: { mode: 'css' }
                    }

                    header.innerHTML = this.floor_manager_metadata;
                }

                let rows = [];
                for (let i = 0; i < table_inputs.length; i++) {
                    rows[i] = document.createElement('tr');
                    let building_code = document.createElement('td');
                    let building_code_div = document.createElement('div');
                    building_code_div.style.pageBreakInside = 'avoid';
                    let floor = document.createElement('td');
                    let floor_div = document.createElement('div');
                    floor_div.style.pageBreakInside = 'avoid';
                    let ap = document.createElement('td');
                    let ap_div = document.createElement('div');
                    ap_div.style.pageBreakInside = 'avoid';
                    let count = document.createElement('td');
                    let count_div = document.createElement('div');
                    count_div.style.pageBreakInside = 'avoid';
                    building_code_div.innerHTML = table_inputs[i].Building;
                    floor_div.innerHTML = table_inputs[i].Floor;
                    ap_div.innerHTML = table_inputs[i].AP;
                    count_div.innerHTML = table_inputs[i].Count;
                    building_code.appendChild(building_code_div);
                    floor.appendChild(floor_div);
                    ap.appendChild(ap_div);
                    count.appendChild(count_div);
                    rows[i].appendChild(building_code);
                    rows[i].appendChild(floor);
                    rows[i].appendChild(ap);
                    rows[i].appendChild(count);
                    rows[i].style.border = '1px solid black';
                    rows[i].style.pageBreakInside = 'avoid';
                    rows[i].style.pageBreakAfter = 'auto';
                    table.appendChild(rows[i]);
                }

                table.style.color = 'blue';
                table.style.border = '2px solid black';
                table.style.borderCollapse = 'collapse';
                table.style.width = '90%';
                table.style.margin = 'auto';
                table.style.pageBreakInside = 'auto';

                report_area.appendChild(header);
                report_area.appendChild(table);
                report_area.style.margin = 'auto';

                html2pdf().set(options).from(report_area).save();
            } else if (style === 'two') {
                let report_area = document.createElement('div');
                let table = document.createElement('table');
                let head1 = document.createElement('th');
                let head2 = document.createElement('th');
                let heading_row = document.createElement('tr');
                head1.innerHTML = 'Building Code'; 
                head2.innerHTML = 'Count';
                heading_row.appendChild(head1);
                heading_row.appendChild(head2);
                table.appendChild(heading_row);
                let header = document.createElement('h3');
                let table_inputs = [];
                let options = {};

                if (type === 'top ten') {
                    table_inputs = this.top_ten_results;

                    options = {
                        filename: 'top_ten_' + this.top_ten_campus_select + '_past_week.pdf',
                        margin: 2,
                        html2canvas: { scale: 3, y: 0,  scrollY: 0},
                        pagebreak: { mode: 'css' }
                    }

                    header.innerHTML = this.top_ten_metadata;
                }

                let rows = [];
                for (let i = 0; i < table_inputs.length; i++) {
                    rows[i] = document.createElement('tr');
                    let building_code = document.createElement('td');
                    let building_code_div = document.createElement('div');
                    building_code_div.style.pageBreakInside = 'avoid';
                    let count = document.createElement('td');
                    let count_div = document.createElement('div');
                    count_div.style.pageBreakInside = 'avoid';
                    building_code_div.innerHTML = table_inputs[i].Building;
                    count_div.innerHTML = table_inputs[i].Count;
                    building_code.appendChild(building_code_div);
                    count.appendChild(count_div);
                    rows[i].appendChild(building_code);
                    rows[i].appendChild(count);
                    rows[i].style.border = '1px solid black';
                    rows[i].style.pageBreakInside = 'avoid';
                    rows[i].style.pageBreakAfter = 'auto';
                    table.appendChild(rows[i]);
                }

                table.style.color = 'blue';
                table.style.border = '2px solid black';
                table.style.borderCollapse = 'collapse';
                table.style.width = '90%';
                table.style.margin = 'auto';
                table.style.pageBreakInside = 'auto';

                report_area.appendChild(header);
                report_area.appendChild(table);
                report_area.style.margin = 'auto';

                html2pdf().set(options).from(report_area).save();
            }
        }
    },
}
</script>